"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupColorTransitions = setupColorTransitions;
var _bricksUtils = require("@titelmedia/bricks-utils");
function getBackgroundColor(element) {
  if (typeof window === 'undefined') {
    return 'transparent';
  }
  const computedStyle = window.getComputedStyle(element);
  return computedStyle.backgroundColor;
}
function setupColorTransitions(useColorTransitions, storyLayoutRef) {
  if (!useColorTransitions || !document) {
    return;
  }
  setInterval(() => {
    _bricksUtils.ScrollTrigger.refresh();
  }, 2000);
  const storyElement = storyLayoutRef.current;
  const sections = storyElement.querySelectorAll('section');
  sections?.forEach(section => {
    const backgroundColor = getBackgroundColor(section);
    section.style.backgroundColor = 'transparent';
    _bricksUtils.gsap.to(storyElement, {
      scrollTrigger: {
        trigger: section,
        start: 'top center',
        end: 'bottom center',
        onToggle: ({
          isActive
        }) => {
          if (isActive) {
            _bricksUtils.gsap.to(storyElement, {
              duration: 0.5,
              backgroundColor: backgroundColor
            });
          }
        }
      }
    });
  });
}
//# sourceMappingURL=ColorTransitions.js.map